/**
 * Created by yeojinyoon on 2015-05-25.
 */
(function() {
  'use strict';

  eclipseApp.controller('CredentialExistModalCtrl', [
    '$scope',
    '$injector',
    '$modalInstance',
    '$window',
    'data',
    'brtSwitchCMS',
    function($scope, $injector, $modalInstance, $window, data, brtSwitchCMS) {
      $scope.isHybridFlow = brtSwitchCMS.brtSwitch.isHybridFlow;
      $scope.data = {};

      if (data) {
        $scope.data = data;
      }
      $scope.okButtonLabel = 'Login';

      $scope.ok = function() {
        $modalInstance.close();
        $window.janrain.capture.ui.renderScreen('signIn');
      };

      $scope.cancel = function() {
        $modalInstance.dismiss('cancel');
      };
    }
  ]);
})();
